import {
  DictionaryCustomFieldType,
  ICustomDictionaryType,
  IDictionaryTypes,
} from '~/services/api/dictionaries/types';

const medicaidTypeDictionary: ICustomDictionaryType = {
  type: IDictionaryTypes.MedicaidType,
  name: 'Medicaid Type',
  addButtonLabel: 'Add Medicaid Type',
  hasDesignedModal: true,
  nameMaxLength: 200,
  customFields: [
    {
      title: 'Description',
      name: 'description',
      type: DictionaryCustomFieldType.TEXTAREA,
      maxLength: 500,
    },
    {
      title: 'Is Expansion',
      name: 'isExpansion',
      type: DictionaryCustomFieldType.CHECKBOX,
    },
  ],
};

export default medicaidTypeDictionary;
